import React, {memo, useMemo, useRef, useState} from "react";
import ChatDivide from "../../assets/img/subject_underline_shine_effect.png";
import ThumbIcon from "../../assets/img/common/emojis/hand_1.png"
import {firestore, usersRef, questionsRef} from "../../config/firebaseConfig";
import {useCollectionData} from "react-firebase-hooks/firestore";
import {getCurrentUser} from "../../pages/root/helpers";
import {ItemStatuses, ItemTypes} from "../../constants";
import ThankYouModal from "../ThankYouModal";


const QnAPanel = ({user, users, height, islive}) => {
    const dummyOne = useRef();

    const query = questionsRef
        // .where('status', '==', ItemStatuses.APPROVED)
        .orderBy('timestamp', 'asc')

    const [questions, x, err] = useCollectionData(query, {idField: 'id'});
    const approvedQuestions = useMemo(() =>
            questions ? questions.filter(_ => _.status === ItemStatuses.APPROVED) : null,
        [questions])

    if (err)
        console.log(err)

    const [inputValue, setInputValue] = useState('');
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const [width, setWidth] = React.useState(window.innerWidth * 0.6);
    const [chatMaxHeight, setChatMaxHeight] = React.useState(window.innerWidth * 0.6);
    React.useEffect(() => {
        if (document.getElementById('video-player')) {
            setChatMaxHeight(document.getElementById('video-player').offsetHeight);
        }
    });


    const [fontSize, setFontSize] = React.useState(window.innerWidth > 900 ? 36 : window.innerWidth * 0.02);

    React.useEffect(() => {
        function handleResize() {
            if (window.innerWidth > 900) {
                setWidth(window.innerWidth * 0.6)
                setFontSize(window.innerWidth * 0.02)
            } else {
                setWidth(window.innerWidth * 0.6)
                setFontSize(window.innerWidth * 0.01)
            }
        }

        window.addEventListener('resize', handleResize)
        dummyOne.current.scrollIntoView({behavior: 'smooth'});
    }, [approvedQuestions]);


    const sendMessage = async (e) => {
        e.preventDefault();
        if (!inputValue.trim() || !user)
            return

        const itemMessage = {
            userId: user.CustID,
            timestamp: Date.now(),
            type: ItemTypes.MESSAGE,
            status: ItemStatuses.SUBMITTED,
            data: inputValue.trim(),
            likes: [],
        };
        await questionsRef.add(itemMessage);
        setInputValue('');
    };


    const likeUnlike = question => {
        const userId = getCurrentUser().CustID;

        const liked = question.likes.some(_ => _ === userId);
        const likesFiltered = question.likes.filter(_ => _ !== userId);
        const newLikes = liked ? likesFiltered :
            [...likesFiltered, userId];

        questionsRef
            .doc(question.id)
            .set({...question, likes: newLikes});
    };


    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            sendMessage(event);
            setModalIsOpen(true);
        }
    };


    return (
            <div className="coverup" style={{width: '100%', height: '100%', zIndex: 5}}>
                <div style={{fontSize: '1.1vw', padding: '0.5vw 1.2vw'}}>
                    <span className="pull-left" style={{padding: 'padding: 0.5vw 1.1vw',}}>Q&amp;A</span>
                </div>
                <img src={ChatDivide} alt="ChatHeader" style={{width: '100%', height: 10, marginTop: -23}}/>
                <div style={{overflowX: 'hidden', height: chatMaxHeight * (window.innerWidth < 1200 ? 0.50 : 0.67)}}
                     className={'custom-scrollbar'}>
                    {users && approvedQuestions && approvedQuestions.map((item, index) => {
                        const messageFromUser = users.find(u => u.CustID === item.userId);
                        return (<div className="thumb-message-box" key={index}>
                            <div>
                                <div className="likeicon react-icon-hand" onClick={() => likeUnlike(item)}/>
                                <div style={{fontSize: '1.1vw'}}>{item.likes.length}</div>
                            </div>
                            <div className="chat-panel-message">
                                <div style={{
                                    fontSize: '1vw',
                                    color: 'lightgray'
                                }}>{messageFromUser.FirstName + " " + messageFromUser.LastName}</div>
                                <div style={{
                                    fontSize: '1.1vw',
                                    textAlign: 'justify',
                                    fontFamily: 'DINPro-Light'
                                }}>{item.data}</div>
                            </div>
                        </div>)
                    })}
                    <span ref={dummyOne}/>
                </div>
                <img src={ChatDivide} alt="ChatHeader" style={{width: '100%', height: 10}}/>
                {islive ? <div className="chatInput chatInput-min message-input-area-qa">
                    <div>You:</div>
                    <div style={{width: '100%'}}>
                        <input type="text"
                               value={inputValue}
                               onChange={(e) => setInputValue(e.target.value)}
                               onKeyDown={handleKeyDown}
                               placeholder="Enter your question here"
                               style={{fontSize: '1em'}}
                        /></div>

                </div>
                :
                  <div className="chatInput chatInput-min message-input-area-conv" style={{margin: '0 12px 0 1.2vw'}}>
                     This feature is no longer available
                  </div>
                }
                <ThankYouModal modalIsOpen={modalIsOpen}
                               handleCloseModal={() => setModalIsOpen(false)}
                               title="Q&amp;A"
                               body="Thank you. All messages will be moderated before being displayed."
                />
            </div>
    )
}

export default memo(QnAPanel);